import { createSlice } from "@reduxjs/toolkit"
import { fetchBonuses } from "./bonuses-thunk"
import { ErrorType } from "@/shared/types"
import { BonusesState } from "../types/types"

const initialState: BonusesState = {
    bonuses: [],
    isLoading: false,
    error: null
}

const bonusesSlice = createSlice({
    name: 'bonuses',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchBonuses.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchBonuses.fulfilled, (state, action) => {
            state.isLoading = false
            state.bonuses = action.payload
            state.error = null
        })
        .addCase(fetchBonuses.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.payload as ErrorType ?? null
        })
    },
})

export default bonusesSlice.reducer